import Swal from "sweetalert2";

export const showAlert = (icon, title, text, options = {}) => {
    return Swal.fire({
        icon,
        title,
        text,
        confirmButtonText: "Close",
        allowOutsideClick: false,
        ...options,
    });
};

export const showConfirm = (title, text, confirmText = "Confirm") => {
    return Swal.fire({
        icon: "question",
        title,
        text,
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
    });
};

export const showSuccess = (title, text = "", options = {}) =>
    showAlert("success", title, text, options);

export const showError = (title, text = "", options = {}) =>
    showAlert("error", title, text, options);

export const showWarning = (title, text = "", options = {}) =>
    showAlert("warning", title, text, options);

export const showInfo = (title, text = "", options = {}) =>
    showAlert("info", title, text, options);

export const showCustomAlert = async (icon, title, text, confirmButtonText = "Close", onConfirm = null) => {
    const result = await Swal.fire({
        icon,
        title,
        text,
        confirmButtonText,
    });
    if (result.isConfirmed && typeof onConfirm === 'function') {
        onConfirm();
    }
};

export const showConfirmDelete = async (title = "Are you sure?", text = "This action cannot be undone.", onConfirm = null) => {
    const result = await Swal.fire({
        title,
        text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
    });
    if (result.isConfirmed && typeof onConfirm === 'function') {
        onConfirm();
    }
    return result.isConfirmed;
};

export const showConfirmAction = (title, confirmText = "Confirm", onConfirm = null) => {
    return Swal.fire({
        title,
        text: `Are you sure you want to ${confirmText.toLowerCase()}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
    }).then((result) => {
        if (result.isConfirmed && typeof onConfirm === 'function') {
            onConfirm();
        }
        return result.isConfirmed;
    });
};

export const showSessionExpired = (onRestoreSession = null) => {
    return Swal.fire({
        icon: "warning",
        title: "Session Expired",
        text: "Your session has expired. Please click 'Restore Session' to continue.",
        confirmButtonText: "Restore Session",
        allowOutsideClick: false,
    }).then((result) => {
        if (result.isConfirmed && typeof onRestoreSession === 'function') {
            onRestoreSession();
        }
        return result.isConfirmed;
    });
};

// Legacy export for backward compatibility
export const showSwal = showAlert;
